module.exports = __webpack_public_path__ + "files/76b69f41c93bca06d7c79b7566920292.png";